import { useEffect, useState } from "react";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../theme/Component/ListMenu";
import { BasicPage } from "../../theme/Component/BasicPage";
import { BasicTable } from "../../theme/Component/BasicTable";
import { Modal } from "../../theme/Component/Modal";
import { ModalConfirm } from "../../theme/Component/ModalConfirm";
import { _ImportResourceCost, _ResourceCost } from "../../../core/services/dataBean/EntityCatalogVdos";
import { CostingCenterSelect } from "../../erp/cellEditor/CostingCenter/CostingCenterSelect";
import { SelectIndirectConstType } from "../IndirectCostType/SelectIndirectConstType";
import { CostingMeasurementConstantsSelect } from "./CostingMeasurementConstantsSelect";
import { FileInput } from "../../theme/Component/FileInput";
import { BasicButton } from "../../theme/Component/BasicButton";



export const ResourceCost = () => {

    const ResourceCost = useDataBean(_ResourceCost);
    const importCost = useDataBean(_ImportResourceCost);
    const single = Singleton.getInstance();
    const [CostingCenter, setCostingCenter] = useState<number>(null)
    const [IndirectCostType, setIndirectCostType] = useState<number>(null)
    const [regexStr, setregexStr] = useState<any>(null)
    const [lista, setLista] = useState<any>([]);
    const [appoGroup, setAppoGroup] = useState<number>(null)
    const [modalimportar, setModalimportar] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [CostingCenter, IndirectCostType, regexStr])

    const getLista = () => {

        ResourceCost.instance.getResourceCostCatalog(CostingCenter, IndirectCostType, regexStr).then(
            (resp: any) => {
                if (resp) {
                    let x = resp;
                    x.forEach((user) => {
                        user.DataBeanProperties.CostingCenter = (user.DataBeanProperties.CostingCenterCode ?? "") + "-" + (user.DataBeanProperties.CostingCenterName ?? "");

                    });
                    setLista(x)
                }
            }
        )

    }

    const create = () => {
        ResourceCost.setBean({
            IDIndirectCostType: ResourceCost.bean.IDIndirectCostType,
            IDCostingCenter: ResourceCost.bean.IDCostingCenter

        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        ResourceCost.deleteItemVoid(ResourceCost.bean.IDResourceCost).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "name": `Eliminar`, "view": false });
            }
        )

    }
    const validarCampos = () => {
        const { Name, IDIndirectCostType, IDCostingCenter, CostingMeasurementUnit, StandardValue, RealValue } = ResourceCost.bean;

        if (!Name || !IDIndirectCostType || !IDCostingCenter || !CostingMeasurementUnit || !StandardValue || !RealValue) {
            toast.warn("Por favor, complete todos los campos obligatorios.");
            return false;
        }
        return true;
    };
    const editaItem = () => {
        if (!validarCampos()) return;

        ResourceCost.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        });
    };
    const abrirresource = () => {
        setModalimportar({ ...modalimportar, "view": true });

    }

    const importResourceCost = () => {
        ////console.log(bean.FileUpload?.Media, bean.FileUpload?.MediaContext, null)
        importCost.instance.importResourceCost(importCost.bean.FileUpload.Media, importCost.bean.FileUpload.MediaContext, null).then(
            (resp) => {
                if (resp) {
                    setModalimportar({ ...modalimportar, "view": false });
                    toast.info(resp);
                }


            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    const head = [
        { title: 'ID', property: 'IDResourceCost', visible: true },
        { title: 'Tipo Costo Indirecto', property: 'IndirectCostTypeName', visible: true },
        // { title: 'Nombre', property: 'Name', visible: true },

        { title: 'Centro de Costo', property: 'CostingCenter', visible: true },
        { title: 'Unidad de Medida', property: 'CostingMeasurementUnitName', visible: true },
        { title: 'Costo Estandard', property: 'StandardValue', visible: true },
        { title: 'Costo Real', property: 'RealValue', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            // { titulo: 'Importar Costos de Recursos', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModalimportar({ ...modalimportar, "name": `Importar Costos de Recursos`, "view": true }) } },
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar ${ResourceCost.bean.Name}`, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Costos de Recursos">
            <div className="row">
                <div className="col-md-4">
                    <CostingCenterSelect fKey="IDCostingCenter" idSelector={CostingCenter} onChange={(e) => { setCostingCenter(parseFloat(e)) }} label="Centro de Costo" />
                </div>
                <div className="col-md-4">
                    <SelectIndirectConstType idSelector={IndirectCostType} onChange={(e) => { setIndirectCostType(e) }} label="Tipo de  Costo Indirecto" returnType="ID" />
                </div>
                <div className="col-md-4">
                    <label>Búsqueda por Texto</label>
                    <input type="text" name="regexStr" className="form-control" value={regexStr} onChange={(e) => { setregexStr(e.target.value) }} />
                </div>
                <div className="col-md-4 mt-4">
                    <BasicButton icon="ri-send-plane-fill" clase="primary" eventClick={abrirresource}>Importar Costos de Recursos</BasicButton>
                </div>
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={ResourceCost.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">

                            <div className="col-md-12">
                                <label>Nombre</label>
                                <input type="text" name="Name" className="form-control" value={ResourceCost.bean.Name} onChange={ResourceCost.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <SelectIndirectConstType idSelector={ResourceCost.bean.IDIndirectCostType} onChange={(e) => { ResourceCost.setBean({ ...ResourceCost.bean, "IDIndirectCostType": e }) }} label="Tipo de  Costo Indirecto" returnType="ID" />
                            </div>
                            <div className="col-md-6">
                                <CostingCenterSelect fKey="IDCostingCenter" idSelector={ResourceCost.bean.IDCostingCenter} onChange={(e) => { ResourceCost.setBean({ ...ResourceCost.bean, "IDCostingCenter": e }) }} label="Centro de Costo" />
                            </div>
                            <div className="col-md-12">
                                <CostingMeasurementConstantsSelect idSelector={ResourceCost.bean.CostingMeasurementUnit} onChange={(e) => { ResourceCost.setBean({ ...ResourceCost.bean, "CostingMeasurementUnit": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Costo Estandard</label>
                                <input type="text" name="StandardValue" className="form-control" value={ResourceCost.bean.StandardValue} onChange={ResourceCost.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>Costo Real</label>
                                <input type="text" name="RealValue" className="form-control" value={ResourceCost.bean.RealValue} onChange={ResourceCost.handleChange} />
                            </div>
                            <div className="col-md-12">
                                <label>Descripción</label>
                                <textarea name="Description" className="form-control" value={ResourceCost.bean.Description} onChange={ResourceCost.handleChange} />
                                {/* <SelectFunctionalID renderValue="" onChange={()=>{}}/> */}
                            </div>
                        </div>
                    </Modal>
                    <Modal modal={modalimportar} updateModal={setModalimportar} eventModal={importResourceCost}>
                        <div className="row">
                            <FileInput directory="ResourceCost" Media={importCost.bean.FileUpload?.Media} MediaContext={importCost.bean.FileUpload?.MediaContext} onCreate={(e: any) => {
                                importCost.setBean({ ...importCost.bean, "FileUpload": e });
                                ; console.log(e)
                            }} />

                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {ResourceCost.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}